import FbButton from 'components/FbUI/FbButton'

type Props = {
  title: string
  message: string
  onClose: () => void
  onConfirm: () => void
}

export function MobileConfirmationModal({
  title,
  message,
  onClose,
  onConfirm,
}: Props) {
  return (
    <div className="fixed bg-gray-50 w-full h-full overflow-scroll flex flex-col gap-4">
      <div className="flex flex-col items-center mt-5 gap-2">
        <div className="text-2xl font-bold">{title}</div>
        <div className="text-gray-400">{message}</div>
      </div>
      <div className="flex gap-2 p-2 justify-between">
        <div className="w-1/2">
          <FbButton
            className="w-full"
            type="button"
            size="lg"
            variant="secondary"
            onClick={onClose}
          >
            Cancel
          </FbButton>
        </div>
        <div className="w-1/2">
          <FbButton
            className="w-full"
            type="button"
            size="lg"
            variant="primary"
            onClick={onConfirm}
          >
            Delete
          </FbButton>
        </div>
      </div>
    </div>
  )
}
